import * as React from 'react';

const SvgFormBlank = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M3 21h18V3H3v18ZM5 5h14v14H5V5Z" })
);

export { SvgFormBlank as default };
//# sourceMappingURL=FormBlank.es.js.map
